import { render, staticRenderFns } from "./border-editor.vue?vue&type=template&id=404dbbbe&scoped=true"
import script from "./border-editor.vue?vue&type=script&lang=js"
export * from "./border-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404dbbbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('404dbbbe')) {
      api.createRecord('404dbbbe', component.options)
    } else {
      api.reload('404dbbbe', component.options)
    }
    module.hot.accept("./border-editor.vue?vue&type=template&id=404dbbbe&scoped=true", function () {
      api.rerender('404dbbbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/border-editor.vue"
export default component.exports